import type { TGetCorretagensResponse } from '@/features/proposta/interfaces/proposta.type'
import { HttpService } from '@/infra/http'

export class GetCorretagens extends HttpService {
  execute = async (simulacoesIds: string[]) => {
    return this.http.get<TGetCorretagensResponse>(`/api/v2/Simulacao/corretagens`, {
      params: { ids: simulacoesIds },
      paramsSerializer: { indexes: null },
    })
  }
}
